export default {
	methods: {
		formatItemArray(item) {
			let itemArray = [];

			if (item instanceof Array) {
				itemArray = item;
			} else if (item) {
				itemArray.push(item);
			}

			return itemArray;
		}
	}
};
